import styled from 'styled-components';

import { transition } from 'ggApp/utils/mixins/transition';

import TopContent from './TopContent';
import BottomContent from './BottomContent';

const Wrap = styled.div`
    width: 100%;
    position: sticky;
    top: 0px;
    z-index: ${({ shouldShowMenu }) => (shouldShowMenu ? 6 : 3)};
    padding-bottom: ${(props) => props.theme.spacers.XL};
`;

const Top = styled(TopContent)`
    ${transition('background-color', 'medium-desktop', 'standard')};
    ${({ isTransparent }) => isTransparent && `
        background: transparent;
    `};
`;

const Bottom = styled(BottomContent)``;

export {
    Wrap,
    Top,
    Bottom,
};
